import { render, staticRenderFns } from "./proposalLibrary.vue?vue&type=template&id=71d6ee90&scoped=true&"
import script from "./proposalLibrary.vue?vue&type=script&lang=js&"
export * from "./proposalLibrary.vue?vue&type=script&lang=js&"
import style0 from "@assets/css/proposal/proposal.less?vue&type=style&index=0&id=71d6ee90&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71d6ee90",
  null
  
)

component.options.__file = "proposalLibrary.vue"
export default component.exports